import { UserRole } from 'shared/types/userRole';

export function isAdmin(role: UserRole): boolean {
  return (
    role === UserRole.projectAdmin ||
    role === UserRole.superAdmin ||
    role === UserRole.organizationAdmin
  );
}
